const $ = jQuery.noConflict();

export default function shareButtons() {
    $("a.btn-share").click(function onClick(eventObject) {
        eventObject.preventDefault();

        const width = 555;
        const height = 500;
        // eslint-disable-next-line no-magic-numbers
        const centerLeft = window.screen.width / 2 - width / 2;
        // eslint-disable-next-line no-magic-numbers
        const centerTop = window.screen.height / 2 - height / 2;
        const url = $(this).attr("href");
        const popupWindow = window.open(
            url,
            "Title",
            `scrollbars=1, width=${width}, height=${height}, left=${centerLeft}, top=${centerTop}`
        );

        popupWindow.focus();
    });
}
